import * as $ from "jquery";

export class MessageDisplay {
    private readonly maxNumDisplayed = 6;
    private readonly displayTime = 2; // In seconds

    public ajaxError(jqXhr: JQueryXHR) {
        let text: string = jqXhr.responseText;

        if (jqXhr.responseJSON != null && Object.prototype.hasOwnProperty.call(jqXhr.responseJSON, 'message')) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            text = jqXhr.responseJSON.message as string;
        }
        this.error(`${jqXhr.status} ${jqXhr.statusText} - ${text}`);
    }

    public error(text: string) {
        this.message(text, 'error');
    }

    public success(text: string) {
        this.message(text, 'success');
    }

    public debug(text: string) {
        this.message(text, 'debug');
    }

    private message(text: string, messageTypeClass: string) {
        const container = $('#modal-container');

        const modal = $(`<div class="info-modal ${messageTypeClass}">${text}</div>`);
        container.prepend(modal);

        modal.hide();
        modal.fadeIn('fast', () => {
            setTimeout(
                () => modal.fadeOut('slow', () => modal.remove()),
                this.displayTime * 1000
            );
        });

        modal.offset({
            top: $(window).scrollTop() + 120,
            left: 0.5 * ($(window).width() - modal.width()) + $(window).scrollLeft()
        });

        const offsetY = modal.height() + 11;

        container.find('.info-modal:not(:first)').animate({
            top: `+=${offsetY}`
        }, 200, null);
    }
}
